import React from "react";
import { Button } from "react-bootstrap";
import { useState, useEffect } from "react";

function ComparisonTable({selectPreliminaryReport, selectPremiumReport, premiumCreditsRemaining})
{
    const [premiumExampleUrl, setPremiumExampleUrl] = useState(null)

    const fetchPageData = (forced) => {
      
        var fUrl = process.env.REACT_APP_API_END_POINT + 'reports/?mode=demo'
    
        fetch(fUrl, {
            headers: {
            'Accept': 'application/json',
            },
            method: "GET",
            credentials: "include"
        })
        .then((resp) => resp.json())
        .then((data) => {
            if (data['success']) {
                setPremiumExampleUrl(data['premium_url'] ?? null)
                // setPreliminaryExampleUrl(data['preliminary_url'] ?? null)
            }
        })
      }

    useEffect(() => {
        fetchPageData()
    }, [])


    return (
        <div className="comparisonTableWrapper">
            <div className="comparisonTable">
                {/* <div className="comparisonTitle" onClick={selectPreliminaryReport}>
                    <p>Preliminary</p>
                </div> */}
                <div></div>
                <div className="comparisonTitle" onClick={selectPremiumReport}>
                    <p>epIMS Home Energy Report</p>
                </div>
                <div></div>
                {/* <div className="reportCoverWrapper" onClick={selectPreliminaryReport}>
                    <div className="reportCover" style={{backgroundImage: 'url("/preliminary_cover_example.jpg")'}}></div>
                </div> */}
                <div className="reportCoverWrapper" onClick={selectPremiumReport}>
                    <div className="reportCover" style={{backgroundImage: 'url("/premium_cover_example.jpg")'}}></div>
                </div>
                <div></div>
                {/* <div className="buttonCell" style={{display: "flex", padding: "10px"}}>
                    <Button style={{marginInline: "auto"}} onClick={selectPreliminaryReport}>Create Preliminary Report</Button>
                </div> */}
                <div className="buttonCell" style={{display: "flex", padding: "10px"}}>
                    <Button id="createReportButtonTop" style={{marginInline: "auto"}} onClick={selectPremiumReport}>Create Report</Button>
                </div>

                { /*preliminaryExampleUrl && */ premiumExampleUrl && <>
                    {/* <div className="comparisonLabel"><p>Sample reports</p></div> */}
                    <div className="comparisonLabel"><p>Sample report</p></div>
                    {/* <div className="comparisonValue comparisonValuePositive"><p><a href={preliminaryExampleUrl} rel="noreferrer" target="_blank">Sample Preliminary Report</a></p></div> */}
                    <div className="comparisonValue comparisonValuePositive" style={{flexDirection: "column", alignItems: "center", paddingBlock: "8px"}}><p style={{fontSize: "14px", width: "90%", textAlign: "center"}}>We have provided a sample report for you to view and use as a guide to see what is included.</p><p><a href={premiumExampleUrl} rel="noreferrer" target="_blank">See Sample Report</a></p></div>
                </>}

                <div></div>
                <div style={{gridColumn: "span 1"}}>
                    <p style={{margin: 0, textAlign: "center", fontWeight: "bold", fontSize: "32px", color: "#303030"}}>Features</p>
                </div>

                <div></div>
                {/* <div className="comparisonHeading"><p>Preliminary</p></div> */}
                <div className="comparisonHeading"><p>epIMS Home Energy Report</p></div>
                <div className="comparisonLabel"><p>Price</p></div>
                {/* <div className="comparisonValue comparisonValuePositive"><p>Free</p></div> */}
                {/* <div className="comparisonValue comparisonValuePositive"><p style={{lineHeight: 1}}>&pound;{(premiumCost / 100).toFixed(2).replace(/\.00$/, '')}{premiumCreditsRemaining > 0 ? <span style={{fontWeight: 400, fontSize: "14px"}}><br/>{premiumCreditsRemaining} free {premiumCreditsRemaining === 1 ? 'credit' : 'credits'} remaining</span> : null}</p></div> */}
                <div className="comparisonValue comparisonValuePositive"><p>Free</p></div>

                <div className="comparisonLabel"><p>Property Overview</p></div>
                {/* <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div> */}
                <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div>
                <div className="comparisonLabel"><p>EPC Overview</p></div>
                {/* <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div> */}
                <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div>
                <div className="comparisonLabel"><p>Grants Report</p></div>
                {/* <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div> */}
                <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div>
                <div className="comparisonLabel"><p>Payback period</p></div>
                {/* <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div> */}
                <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div>
                <div className="comparisonLabel"><p>Pros, cons &amp; alerts</p></div>
                {/* <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div> */}
                <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div>
                <div className="comparisonLabel"><p>Multiple routes to improve property</p></div>
                {/* <div className="comparisonValue comparisonValueNegative"></div> */}
                <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div>
                <div className="comparisonLabel"><p>In depth recommendation details</p></div>
                {/* <div className="comparisonValue comparisonValueNegative"></div> */}
                <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div>
                <div className="comparisonLabel"><p>epIMS Toolbox</p></div>
                {/* <div className="comparisonValue comparisonValueNegative"></div> */}
                <div className="comparisonValue comparisonValuePositive"><p>&#10003;</p></div>

                <div></div>
                {/* <div className="buttonCell" style={{display: "flex", padding: "10px"}}>
                    <Button style={{marginInline: "auto"}} onClick={selectPreliminaryReport}>Create Preliminary Report</Button>
                </div> */}
                <div className="buttonCell" style={{display: "flex", padding: "10px"}}>
                    <Button id="createReportButtonBottom" style={{marginInline: "auto"}} onClick={selectPremiumReport}>Create Report</Button>
                </div>
            </div>
        </div>
    )
}

export default ComparisonTable;